import { createHigherOrderComponent } from "@wordpress/compose";
import { Component, Fragment } from "@wordpress/element";
import { InspectorControls } from "@wordpress/block-editor";
import { TabPanel } from "@wordpress/components";
import {TabNames} from "~buildable/utils/enums";

import getBlockStyleOptions from "~buildable/utils/get-block-style-options";
import getBlockAdditionalOptions
  from "~buildable/utils/get-block-additional-options";

const withInspectorTabs = (tabs = null, renderTabContent) => createHigherOrderComponent(
  WrappedComponent => class extends Component {
    renderTabContent(tab, props) {
      if (typeof renderTabContent !== "undefined") {
        const blockTabContent = renderTabContent(tab, props);
        if (blockTabContent !== null && typeof blockTabContent !== "undefined") {
          return renderTabContent(tab, props);
        } else if (typeof blockTabContent === "undefined") {
          return <div className="text-only">No options available.</div>;
        }
      }

      switch (tab.name) {
        case TabNames.DETAILS:
          return (
            <div className="text-only">
              Modify options in the Style and Additional tabs.
            </div>
          )
        case TabNames.STYLE:
          return getBlockStyleOptions(props);
        case TabNames.ADDITIONAL:
          return getBlockAdditionalOptions(props);
        default:
          return null;
      }
    }

    render() {
      if (!tabs || !tabs.length) {
        return <WrappedComponent { ...this.props } />
      }

      const actualRenderTabContent = this.renderTabContent;

      return (
        <Fragment>
          <InspectorControls>
            <TabPanel
              className="inspector-tabs"
              tabs={ tabs }
              initialTabName={ TabNames.DETAILS }
            >
              {
                tab => actualRenderTabContent(tab, this.props)
              }
            </TabPanel>
          </InspectorControls>

          <WrappedComponent { ...this.props } />
        </Fragment>
      )
    }
  },
  'withInspectorTabs'
)

export default withInspectorTabs;
